<template>
  <div class="custom-input text">
    <div class="input-inner">
      <div v-if="label" :class="getLabelClass">{{ $t(label) }}</div>

      <b-input-group v-if="allowModify">
        <b-form-file v-model="fileVal" :required="required" :accept="types"
                     :placeholder="$t(placeholder)" :drop-placeholder="dropPlaceholder"
                     :browse-text="$t('_browse') "
        >
          <template slot="file-name" slot-scope="{ names }">
            <b-badge class="orange-white">{{ names[0] }}</b-badge>
          </template>
        </b-form-file>

        <template #append>
          <base-button v-if="fileVal" fa-class="trash" @click="fileVal = null" />
        </template>
      </b-input-group>
    </div>
    <div class="value"
         :class="valueClass"
    >
      <b-img v-if="imageValMutable"
             :src="imageValMutable"
             :title="title"
             :alt="alt"
             center
             thumbnail
             fluid
      />
    </div>
  </div>
</template>

<script>
import error from '@/components/frontoffice/form/error'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import baseButton from '@/components/backoffice/button/base'
import bImg from 'bootstrap-vue/es/components/image/img'

export default {
  components: {
    error,
    baseButton,
    bImg
  },

  mixins: [formMethods],

  props: {
    value: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    label: String,
    placeholder: {
      type: String,
      default: 'fileInput.placeholder'
    },
    types: [String, File],
    title: String,
    alt: String,
    alone: Boolean,
    imageVal: String,
    allowModify: {
      Boolean,
      default: true
    }
  },

  data () {
    return {
      fileVal: this.value,
      imageValMutable: this.imageVal,
      // placeholder: this.$t('fileInput.placeholder'),
      dropPlaceholder: this.$t('fileInput.drop')
    }
  },

  watch: {
    value (newVal) {
      this.fileVal = newVal
    },

    fileVal (newVal) {
      console.log(newVal)
      var reader = new FileReader()
      reader.readAsDataURL(newVal)
      var current = this
      reader.onload = function () {
        current.imageValMutable = reader.result
        current.$emit('input', reader.result)
      }
      reader.onerror = function (error) {
        console.log('Error: ', error)
      }
    }
  },

  computed: {
    labelClass () {
      return this.alone ? 'col-2' : 'col-4'
    },

    valueClass () {
      if (this.label) {
        return this.alone ? 'col-10' : 'col-8'
      }
    }
  }
}
</script>
